// ─── Regex Patterns ───
export const PINCODE_REGEX = /^[1-9][0-9]{5}$/;
export const MOBILE_REGEX = /^[6-9][0-9]{9}$/;
export const CONTACT_NAME_REGEX = /^[a-zA-Z\s]+$/;
export const IFSC_REGEX = /^[A-Z]{4}0[A-Z0-9]{6}$/;
export const ACCOUNT_NUMBER_REGEX = /^[0-9]{9,18}$/;
export const USERNAME_REGEX = /^[a-zA-Z0-9\s\-_.,@&*\';]+$/;
 
// ─── Error Messages ───
export const GENERAL_ERRORS = {
  pincode: "Must be a 6-digit PIN code",
  mobile: "Must be a 10-digit mobile number",
  mobileStart: "Must start with 6, 7, 8, or 9",
  contactName: "Name must contain only alphabets",
  ifsc: "Invalid IFSC format",
  payee: "Payee name must contain only alphabets",
  accountNumber: "Must be 9 to 18 digits",
};
 
// ─── Input Sanitizers (Filtering on type) ───
export const sanitizePincode = (value) => {
  let sanitized = value.replace(/[^0-9]/g, "");
  if (sanitized.startsWith("0")) {
    sanitized = sanitized.substring(1);
  }
  return sanitized.slice(0, 6);
};

export const sanitizeMobile = (value) => value.replace(/[^0-9]/g, "").slice(0, 10);

export const sanitizeContactName = (value) => value.replace(/[^a-zA-Z\s]/g, "");

export const sanitizeIfsc = (value) => value.toUpperCase().replace(/[^A-Z0-9]/g, "").slice(0, 11);

export const sanitizeAccountNumber = (value) => value.replace(/[^0-9]/g, "").slice(0, 18);

export const sanitizeGeneralText = (value) => {
  if (!value || typeof value !== "string") return value;
  return value.replace(/[^a-zA-Z0-9\s\-_.,@&*;:\'\"]/g, "");
};

export const sanitizeUsername = (value) => {
  if (!value || typeof value !== "string") return value;
  return value.replace(/[^a-zA-Z0-9\s\-_.,@&*\';]/g, "");
};

export const limitWords = (text, limit) => {
  if (!text || typeof text !== "string") return text;
  const words = text.trim().split(/\s+/).filter(Boolean);
  if (words.length <= limit) return text;
  
  let count = 0;
  let i = 0;
  let inWord = false;
  for (i = 0; i < text.length; i++) {
    const isSpace = /\s/.test(text[i]);
    if (!isSpace && !inWord) {
      inWord = true;
      count++;
      if (count > limit) {
        break;
      }
    } else if (isSpace) {
      inWord = false;
    }
  }
  return text.slice(0, i).trimEnd();
};

// ─── Inline Validation Checkers ───
export const checkMobileStart = (value) => {
  if (value.length > 0 && !/^[6-9]/.test(value)) {
    return GENERAL_ERRORS.mobileStart;
  }
  return "";
};
